export default __webpack_public_path__ + "static/media/amazing-work.517f566b.gif";